import IndicateFriends from "../../components/indicate_friends/IndicateFriends.vue"

export default {
    components: { IndicateFriends },

    data: () => ({
        customItemsIndicateFriends: {},
        loading: false
    }),

    async created() {
        window.scrollTo(0,0);
        this.loading = !this.loading
        this.customItemsIndicateFriends = this.DATACUSTOM.text
        this.loading = !this.loading
    }
}